import { useTranslation } from 'react-i18next';

import NoConnectionStub from '@assets/Images/stub/no-connection-stub.svg';
import { Stub } from '@shared/ui-kit';

export const NoInternetConnection = () => {
  const { t } = useTranslation();

  return (
    <Stub
      config={{
        title: t('stubs.noInternetConnectionStub.title'),
        description: t('stubs.noInternetConnectionStub.subtitle'),
        img: NoConnectionStub,
      }}
    />
  );
};
